import saga from 'Modules/changePlan/store/saga'
import reducer from 'Modules/changePlan/store/reducer'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { useDispatch, useSelector } from 'react-redux'
import { makeSelectChangePlan } from 'Modules/changePlan/store/selectors'
import { changeBasic, changeRegisterPlan, changeTeamPlan, getPlan } from 'Modules/changePlan/store/actions'

export const useChangePlan = () => {
  useInjectSaga({ key: 'changePlan', saga })
  useInjectReducer({ key: 'changePlan', reducer })

  const { plan } = useSelector(
    makeSelectChangePlan()
  )

  const dispatch = useDispatch()
  const getPlanAction = () => dispatch(getPlan())
  const changeTeamPlanAction = (payload) => dispatch(changeTeamPlan(payload))
  const changeRegisterPlanAction = (payload) => dispatch(changeRegisterPlan(payload))
  const changeBasicAction = () => dispatch(changeBasic())

  return {
    plan,
    getPlanAction,
    changeTeamPlanAction,
    changeRegisterPlanAction,
    changeBasicAction
  }
}
